import EmailVerificationCodeForm from "../components/EmailVerificationCodeForm";

export default function EmailVerificationCode() {
  return (
    <div className="relative z-10 w-full max-w-md px-6 py-40">
      <EmailVerificationCodeForm />
    </div>
  );
}
